import React, { Component } from 'react';
import { Modal, Button, Table, Form, Input, Divider, message, Select, Cascader, Tooltip } from 'antd';
import axios from '../../service/index'
import copy from "copy-to-clipboard"
const { Option } = Select;
// const { TabPane } = Tabs;
const handleCopy = value => { copy(value); message.success('链接已复制') }
class ChannelManagement extends Component {

	constructor(props) {
		super(props)
		this.state = {
			visible: false,
			total: 0,

			isTeacher: 2,
			labelName: '',
			allowClear: false,
			labelId: null,
			modelTitle: '新增渠道',
			btnColor: true,
			subjectList: [],
			zsChannelList: [],
			shareUserList: [],
			searchData: {
        channelName: '',
				pageNum: 1,
				pageSize: 10,
			},
			enrollmentChannelList: [],
			channelTypeList: [],
			sourceTypeList: [],
			pageList: [],
			smallPage: [],
			pxSize: 500,
			residences: [],
			getTeachersList: [],
      channelName1: '',
      channelType1: '',
      sourceType1: '',
      subjectId1: '',
      shareUserId: '',
      zsChanneId: '',
			tableList: [],
			sourceType: '',
			channelType: '',
			subjectId: '',
			channelName: '',
      zsChannelId: '',
      id: '',
      columns: [
				{
					title: '渠道名称',
					dataIndex: 'channelName',
					key: 'channelName',
					// align: 'center'
					width: 120,
					ellipsis: true,
					render: (text, record) => (
						  <Tooltip placement="topLeft" title={text}>{text}</Tooltip>//触碰提示
					)
				},
				{
					title: '链接类型',
					dataIndex: 'channelTypeName',
					key: 'channelTypeName',
					width: '100px',
					align: 'center'
				},
				{
					title: '对应招生渠道',
					dataIndex: 'zsChannelName',
					key: 'zsChannelName',
					align: 'center',
					width: '120px',
					ellipsis: true
				},
				{
					title: '裂变人',
					dataIndex: 'shareUserName',
					key: 'shareUserName',
					align: 'center',
					width: '120px'
				},
				{
					title: '关联学科',
					dataIndex: 'subjectName',
					key: 'subjectName',
					align: 'center',
					width: '100px',
				},
				{
					title: '小程序页面',
					dataIndex: 'smallPageName',
					key: 'smallPageName',
					minWidth: '130px',
					ellipsis: true,
					render: (text, record) => (
						<Tooltip placement="topLeft" title={text}>{text}</Tooltip>//触碰提示
					)
				},
				{
					title: '二维码尺寸',
					dataIndex: 'pxSize',
					width: '110px',
					key: 'pxSize',
					align: 'center'
				},
				{
					title: '跳转链接',
					dataIndex: 'jumpUrl',
					key: 'jumpUrl',
					ellipsis: true,
					render: (text, record) => (
						<Tooltip placement="topLeft" title={text}>{text}</Tooltip>//触碰提示
				)
				},
				{
					title: '点击量',
					dataIndex: 'clickNum',
					key: 'clickNum',
					align: 'center',
					width: '80px',
				},
				{
					title: '操作',
					align: 'center',
					width: '240px',
					render: (record) => <div>
						<span style={{ marginRight: '15px', color: '#277FFF', cursor: 'pointer' }} onClick={() => {
              console.log(record);
							this.setState({
								id: record.id,
								visible: true,
								modelTitle: '编辑渠道',
								channelName: record.channelName,
                channelType: record.channelType,
                zsChannelId: record.zsChannelId,
                smallPage: record.smallPage,
                subjectId: record.subjectId

							})
						}}>编辑</span>
						<span style={{ marginRight: '15px', color: '#277FFF', cursor: 'pointer' }} onClick={() => {
							this.props.history.push({ pathname: '/channelIndex', state: { id: record.id } })
						}}>详情</span>
						<span style={{ marginRight: '15px', color: '#277FFF', cursor: 'pointer' }} onClick={() => {
							handleCopy(record.jumpUrl)
						}}>复制链接</span>
					</div>
				},
			],
		}
	}
	componentDidMount() {
		this.getSubjectList()
		this.getTableList()
		this.getPageList()
		this.getChannelType()
    this.getEnrollmentChannelList()
		this.getSourceType()
		this.getAllTeachersByDepartment()
	}
	componentWillUnmount() {
		this.setState = () => false;
	}
	handleOk = (e) => {
		this.props.form.validateFields(async (err, values) => {
			console.log(err, values)
			let params = { ...values }
      let id = this.state.id
      params.zsChannelId = values.zsChannelId
      params.zsChannelName = values.zsChannelId.label
      if(this.state.modelTitle === '新增渠道') {
        params.shareUserId = values.shareUserId[1]
      }

			if (!err) {
        let url = this.state.modelTitle === '新增渠道' ? 
          'jumpUrlConfigController/addConfig' : 'jumpUrlConfigController/updateById'

        let editParams = {
          id,
          channelName: params.channelName,
          zsChannelId: params.zsChannelId
        }
        const {data:res} = await axios.post(url, this.state.modelTitle === '新增渠道' ? {...params} : editParams)
        if (res.code === '200') {
          message.success(this.state.modelTitle === '新增渠道' ? '添加成功' : '编辑成功')
          
          this.setState({
            visible: false,
            channelName: '',
            channelType: '',
            modelTitle: '新增渠道',
            subjectId: '',
            sourceType: ''
          })
          this.getTableList()
        } else {
          message.error(res.msg)
        }

				// if (this.state.modelTitle === '新增渠道') {
				// 	const {data: res} = await axios.post('jumpUrlConfigController/addConfig', {...params})
        //   if (res.code === '200') {
        //     message.success('添加成功')
        //     this.getTableList()
        //     this.setState({
        //       visible: false
        //     })
        //   } else {
        //     message.error(res.msg)
        //   }
				// }else if(this.state.modelTitle === '编辑渠道') {
        //   console.log(123);
        //   console.log(this.state.modelTitle);
        //   // console.log(this.state.id);
        //   // return
        //   axios.post('', {
				// 		id,
        //     name: params.channelName,
        //     zsChannelId: params.zsChannelId
				// 	}).then(res => {
				// 		if (res.data.code === '200') {
				// 			message.success('编辑成功')
				// 			this.getTableList()
				// 			this.setState({
				// 				visible: false
				// 			})
				// 		} else {
				// 			message.error(res.data.msg)
				// 		}
				// 	})
        // }
			}
		})
	}
	getTableList = () => {
		axios.post('jumpUrlConfigController/query', {
			...this.state.searchData,
			sourceType: this.state.sourceType1,
			channelName: this.state.channelName1,
			channelType: this.state.channelType1,
			subjectId: this.state.subjectId1,
			zsChannelId: this.state.zsChanneId,
			shareUserId: this.state.shareUserId[1],
		}).then(res => {
			if (res.data.code === '200') {
				this.setState({
					tableList: res.data.data.list,
					total: res.data.data.total
				})
			}
		})
	}
	getSubjectList = () => {
		axios.get('subjectController/getOption').then(res => {
			if (res.data.code === '200') {
				this.setState({
					subjectList: res.data.data
				})
			}
		})
	}
	getPageList = () => {
		axios.get('jumpUrlConfigController/getPageDetails').then(res => {
			if (res.data.code === '200') {
				this.setState({
					pageList: res.data.data
				})
			}
		})
	}
	getSourceType = () => {
		axios.get('jumpUrlConfigController/getSourceType').then(res => {
			if (res.data.code === '200') {
				this.setState({
					sourceTypeList: res.data.data
				})
			}
		})
	}
  onSearch = (value) => {
    console.log('search:', value);
  }
  filterOption(input, option) {
    console.log(input);
    console.log(option);
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
  }
	// 对应招生渠道
	getEnrollmentChannelList = () => {
		axios.get('/jumpUrlConfigController/getZsChannel').then(({data: res}) => {
			if (res.code === '200') {
				this.setState({
					enrollmentChannelList: res.data,
					zsChannelList: res.data
				})
			}
		})
	}
	getChannelType = () => {
		axios.get('jumpUrlConfigController/getChannelType').then(res => {
			if (res.data.code === '200') {
				this.setState({
					channelTypeList: res.data.data
				})
			}
		})
	}
	getAllTeachersByDepartment = () => {
		axios.get('userController/getAllTeachersByDepartment').then(res => {
			if (res.data.code === '200') {
				this.setState({
					residences: res.data.data,
					shareUserList: res.data.data,
				})
			}
		})
	}
	handleCancel = () => {
		this.setState({
			visible: false
		})
	};
	filter(inputValue, path) {
		return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
	}
	render() {
		const { tableList, modelTitle, visible, total, columns, subjectList, residences, zsChannelList, shareUserList } = this.state
		const { getFieldDecorator } = this.props.form;
		const pagination = {
			showSizeChanger: true,
			total: total,
			pageSizeOptions: ['10', '20', '30', '40'],
			showTotal: () => `共 ${total} 条`,
			onShowSizeChange: (current, pageSize) => {
				let searchData = this.state.searchData
				searchData.pageNum = current
				searchData.pageSize = pageSize
				this.getTableList()
			},
			onChange: (current) => {
				let searchData = this.state.searchData
				searchData.pageNum = current
				this.getTableList()
			},
		}
		return (
			<div className="userlist">
				<span style={{ display: 'flex', alignItems: 'center', fontSize: '18px', fontWeight: '600' }}>渠道管理</span>
				<Divider />
				<div style={{ display: 'flex', justifyContent: 'space-between' }}>
					<div style={{ display: 'flex', flexWrap: 'wrap' }}>
						<Input allowClear value={this.state.channelName1} style={{ width: '160px', height: '40px', marginRight: '20px', marginBottom: '20px' }}
							placeholder="关键字搜索"
							onChange={(e) => {
								this.setState({
									channelName1: e.target.value
								})
							}}
						></Input>
						<div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
							<span>链接类型：</span>
							<Select placeholder="请选择学科" value={this.state.channelType1} style={{ width: 200, height: '40px' }} onChange={(value) => {
								this.setState({
									channelType1: value
								})
							}}>
								<Option value={""}>全部</Option>
								{
									this.state.channelTypeList.map(item => {
										return <Option key={item.id} value={item.id}>{item.des}</Option>
									})
								}
							</Select>
						</div>
						<div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
							<span>渠道类型：</span>
							<Select placeholder="请选择学科" value={this.state.sourceType1} style={{ width: 200, height: '40px' }} onChange={(value) => {
								this.setState({
									sourceType1: value
								})
							}}>
								<Option value={""}>全部</Option>
								{
									this.state.sourceTypeList.map(item => {
										return <Option key={item.id} value={item.id}>{item.des}</Option>
									})
								}
							</Select>
						</div>
						<div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
							<span>关联学科：</span>
							<Select placeholder="请选择学科" value={this.state.subjectId1} style={{ width: 200, height: '40px' }} onChange={(value) => {
								this.setState({
									subjectId1: value
								})
							}}>
								<Option value={""}>全部</Option>
								{
									subjectList.map(item => {
										return <Option key={item.id} value={item.id}>{item.name}</Option>
									})
								}
							</Select>
						</div>
						<div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
							<span>对应招生渠道：</span>
							<Select placeholder="请选择对应招生渠道" value={this.state.zsChanneId} style={{ width: 200, height: '40px' }} onChange={(value) => {
								this.setState({
									zsChanneId: value
								})
							}}>
								<Option value={""}>全部</Option>
								{
									zsChannelList.map(item => {
										return <Option key={item.did} value={item.did}>{item.dname}</Option>
									})
								}
							</Select>
						</div>
						<div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
							<span>裂变人：</span>
							<Cascader fieldNames={{ label: 'kefuName', value: 'id' }}  placeholder="请选择裂变人" value={this.state.shareUserId} allowClear options={shareUserList} showSearch={true} onChange={(value) => {this.setState({
									shareUserId: value
								})}} />
						</div>
						<Button className='my-button-primary' style={{ marginLeft: '20px' }} type='primary' onClick={() => {
							this.getTableList()
						}}>搜索</Button>
						<span className='my-button-txt' style={{ marginLeft: '20px', marginBottom: '20px' }} type='primary' onClick={() => {
							this.setState({
								sourceType1: '',
								channelType1: '',
								subjectId1: '',
								zsChanneId: '',
								shareUserId: '',
								channelName1: ''
							}, () => {
								this.getTableList()
							})
						}}>重置</span>
					</div>
					<div>
						<Button className='my-button-primary' style={{ marginLeft: '20px', marginBottom: '20px' }} type='primary' onClick={() => {
							this.setState({ visible: true,modelTitle: '新增渠道' })
						}}>新增渠道</Button>
					</div>
				</div>
				<Table
					pagination={pagination}
					dataSource={tableList}
					columns={columns}
					rowKey={record => record.id}
					rowClassName={(record, index) => (index % 2 !== 0 ? 'table-line' : '')}
				/>

				<Modal
					getContainer={true}
					title={modelTitle}
					okText="确认"
					cancelText="取消"
					visible={visible}
					onOk={() => { this.handleOk() }}
					onCancel={() => { this.setState({ visible: false }) }}
					destroyOnClose
				>
					<Form labelCol={{ span: 6 }} wrapperCol={{ span: 12 }} onSubmit={this.handleOk} autoComplete="off">
						<Form.Item label={"渠道名称"}>
							{getFieldDecorator('channelName', {
								rules: [{ required: true,  message: '请输入渠道名称!', }],
								initialValue: modelTitle === '编辑渠道' ? this.state.channelName : undefined
							})(
								<Input placeholder='请输入渠道名称' />
							)}
						</Form.Item>
            {/* showSearch
                  optionFilterProp="children"
                  filterOption={this.filterOption} */}
						<Form.Item label={"对应招生渠道"}>
              {getFieldDecorator('zsChannelId', {
								rules: [{ required: true, message: '请选择渠道' }],
								initialValue: modelTitle === '编辑渠道' ? this.state.zsChannelId : undefined
							})(
								<Select
									placeholder="请选择渠道"
                  allowClear
                  showSearch
                  optionFilterProp="children"
								>
									{this.state.enrollmentChannelList.map(item=>{
										return (<Option key={item.did} value={item.did}>{item.dname}</Option>)
									})}
								</Select>
							)}
						</Form.Item>
						<Form.Item label={"链接类型"}>
							{getFieldDecorator('channelType', {
                rules: [{ required: true, message: '请选择链接类型' }],
								initialValue: modelTitle === '编辑渠道' ? this.state.channelType : undefined
							})(
								<Select
									placeholder="请选择链接类型"
                  disabled={modelTitle === '编辑渠道' ? true : false}
								>
									{this.state.channelTypeList.map(item => {
										return (<Option key={item.id} value={item.id}>{item.des}</Option>)
									})}
								</Select>
							)}
						</Form.Item>
						{/* <Form.Item label={"渠道类型"}>
							{getFieldDecorator('sourceType', {
								// rules: [{  message: '请选择渠道类型!', }],
								initialValue: undefined
							})(
								<Select
									placeholder="请选择渠道类型"
								>
									{this.state.sourceTypeList.map(item => {
										return (<Option key={item.id} value={item.id}>{item.des}</Option>)
									})}
								</Select>
							)}
						</Form.Item> */}
            {modelTitle === '新增渠道' ? 
            <Form.Item label={"裂变人"}>
            {getFieldDecorator('shareUserId', {
              initialValue: [],
              rules: [
                { required: true, type: 'array',  message: '请选择裂变人!' },
              ],
            })(<Cascader fieldNames={{ label: 'kefuName', value: 'id' }} options={residences} showSearch={true} />)}
          </Form.Item>
           : ''}
						
						<Form.Item label={"跳转小程序页面"}>
							{getFieldDecorator('smallPage', {
								rules: [{ required: true, message: '请选择小程序页面!', }],
								initialValue: modelTitle === '编辑渠道' ? this.state.smallPage : undefined
							})(
								<Select
									placeholder="请选择小程序页面"
                  disabled={modelTitle === '编辑渠道' ? true : false}
								>
									{this.state.pageList.map(item => {
										return (<Option key={item.id} value={item.id}>{item.des}</Option>)
									})}
								</Select>
							)}
						</Form.Item>
            <Form.Item label={"关联学科"}>
							{getFieldDecorator('subjectId', {
								// rules: [{  message: '请选择关联学科!', }],
								initialValue: modelTitle === '编辑渠道' ? this.state.subjectId : undefined
							})(
								<Select
									placeholder="请选择关联学科"
                  disabled={modelTitle === '编辑渠道' ? true : false}
								>
									{subjectList.map(item => {
										return (<Option key={item.id} value={item.id}>{item.name}</Option>)
									})}
								</Select>
							)}
						</Form.Item>
						{/* <Form.Item label={"二维码尺寸"}>
							{getFieldDecorator('pxSize', {
								// rules: [{ message: '请选择二维码尺寸!', }],
								initialValue: undefined
							})(
								<Radio.Group>
									<Radio value={500}>500px</Radio>
									<Radio value={2000}>2000px</Radio>
								</Radio.Group>
							)}
						</Form.Item> */}
					</Form>
				</Modal>
			</div>
		)
	}

};

export default Form.create()(ChannelManagement)